if(!customElements.get('contact-form')) {
  class ContactForm extends HTMLElement {
  	constructor() {
      super();
      this.useKlaviyo = this.dataset.useKlaviyo=='true';
      this.querySelector('form').addEventListener('submit', this.contactFormSubmitHandler.bind(this));

      if (window.location.search.includes('form_type=customer')) {
        this.querySelector('.already-registered').classList.remove('hide');
      }
    }

    contactFormSubmitHandler(e) {
      var self = this;
      var form = self.querySelector('form');
      var error = false;
      var errorMsg = form.querySelector('.error-msg');
      var msg = '';
      var requiredFields = [];

      errorMsg.style.display = 'none';
      form.querySelectorAll('.error').forEach((elem)=>{
        elem.classList.remove('error');
      });
      form.querySelectorAll('.required').forEach((elem)=>{
        if(elem.value=="" || elem.type=="checkbox" && !elem.checked) {
          error = true;
          elem.classList.add('error');
          if (elem.ariaLabel) {
            requiredFields.push(elem.ariaLabel);
          } else if (elem.placeholder) {
            requiredFields.push(elem.placeholder);
          } else if (elem.labels && elem.labels.length > 0) {
            requiredFields.push(elem.labels[0].innerText);
          }
        }
      });
      if (requiredFields.length==1) {
        msg = 'Please complete the ' + requiredFields[0];
      }
      if(error) {
        errorMsg.innerHTML = msg || 'Please complete all the required fields.';
        errorMsg.style.display = 'block';
      } else {
        if(!$s.validateEmail(form.querySelector('.email').value)) {
          error = true;
          form.querySelector('.email').classList.add('error');
          errorMsg.style.display = 'block';
          errorMsg.innerHTML = 'Please provide a valid email address.';
        }
      }
      if(!error) {
        var onsubmit = form.getAttribute('onsubmit');
        if (onsubmit && onsubmit.indexOf('recaptcha')>-1) {
          return true;
        }

        e.preventDefault();
        e.stopImmediatePropagation();

        var params = {
          data: new FormData(form),
          success: function(data, response){
            if(response.url.includes('/challenge')) {
              form.removeEventListener('submit', self.contactFormSubmitHandler);
              form.submit();
            } else {
              form.querySelector('.form-wrap').style.display = 'none';
              form.querySelector('.success-msg').style.display = 'block';
              self.dispatchEvent(new CustomEvent('submitSuccess'));
            }
          },
          error: function(){
            form.removeEventListener('submit', self.contactFormSubmitHandler);
            form.submit();
          }
        }
        if (self.useKlaviyo) {
          params['url'] = form.dataset.ajaxSubmit;
        } else {
          params['url'] = form.getAttribute('action');
          params['type'] = 'text';
        }

        $s.post(params);
      } else {
        e.preventDefault();
        e.stopImmediatePropagation();
        
      }
    }


  }
  customElements.define('contact-form', ContactForm);
}


